<template>
  <a @click.prevent="onChapterClick">
    <PlusIcon class="plus-icon" :class="{'plus-icon--active': $route.name === 'Chapters'}" />

    <transition name="fade" mode="out-in">
      <span v-if="$route.name == 'Chapters'">Close</span>
      <span v-else>Chapters</span>
    </transition>
  </a>
</template>

<script>
import PlusIcon from '@/assets/svg/plus.svg'

export default {
  name: 'ChapterButton',

  components: {
    PlusIcon
  },

  methods: {
    onChapterClick () {
      if (this.$route.name === 'Chapters') {
        this.$router.back()
      } else {
        this.$router.push({
          name: 'Chapters',
          params: {
            language: this.$route.params.language
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">

a:hover {
  span {
    color: $c-red;
  }
}

span {
  font-family: 'Barlow', sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: left;

  margin-left: 2px;
  vertical-align: middle;

  @include breakpoint('md-and-up') {
    font-size: 17px;
    margin-left: 10px;
  }
}

.plus-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  transition: transform 0.4s $ease-out-sine;

  &--active {
    transform: rotate(45deg) scale(1);
  }
}

</style>
